import axios from 'axios';

class Auth {

  /**
   * Authenticate a user. Save a token string in Local Storage
   *
   * @param {string} token
   */
  static authenticateUser(resp) {
    localStorage.setItem('token', resp.token);
    localStorage.setItem('user', JSON.stringify(resp.user));
  }

  /**
   * Check if a user is authenticated - check if a token is saved in Local Storage
   *
   * @returns {boolean}
   */
  static isUserAuthenticated() {
    const token = localStorage.getItem('token');
    return  token !== null && token !== "false";
  }

  /**
   * Deauthenticate a user. Remove a token from Local Storage.
   *
   */
  static deauthenticateUser() {
    delete axios.defaults.headers.common['authorization'];
    localStorage.removeItem('token');
  }

  /**
   * Get a token value.
   *
   * @returns {string}
   */

  static getToken() {
    return localStorage.getItem('token');
  }

  static getRole() {
    return localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')).role;
  }

  static getAdmin() {
    return localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')).admin;
  }

  static getShared() {
    return localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')).sharedwith;
  }

  static getReviewer() {
    return localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')).reviewer;
  }

  static getApprover() {
    return localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')).approver;
  }

}

export default Auth;



// WEBPACK FOOTER //
// ./src/store/auth.js